import Icon from 'veui/components/Icon'

Icon.register({
  image: {
    paths: [
      {
        d: 'M41 6a5 5 0 015 5v26a5 5 0 01-5 5H7a5 5 0 01-5-5V11a5 5 0 015-5h34zm0 4H7a1 1 0 00-1 1v26a1 1 0 001 1h34a1 1 0 001-1V11a1 1 0 00-1-1zM19.45 21.39c.22.13.43.29.6.47l.13.15 4.85 5.89 3.45-4a2.7 2.7 0 013.17-.65l.17.09c.2.12.4.26.57.43l.13.13 5 5.8a2 2 0 01-2.92 2.73l-.11-.12-3.99-4.62-3.99 4.62-.11.12-.12.1v.01l.06-.06a2 2 0 01-.72.42l-.03.01-.12.04h-.03a1.8 1.8 0 01-.12.02h-.03l-.1.02h-.12l-.05.01h-.05a2.1 2.1 0 01-.15 0l-.06-.01a1.73 1.73 0 01-.53-.14 2.1 2.1 0 01-.43-.25l-.1-.09-.13-.11-.08-.1.05.07a2 2 0 01-.09-.1L18 25.64l-5.46 6.62a2 2 0 01-3.18-2.41l.1-.13L15.82 22a2.87 2.87 0 013.63-.62zM32.5 13a3.5 3.5 0 110 7 3.5 3.5 0 010-7z'
      }
    ],
    width: '48',
    height: '48'
  }
})
